import { semiBoldFontWeight } from '@globals/themes/themeConstants'
import InputLabel, { InputLabelOwnProps } from '@mui/material/InputLabel'
import { SxProps } from '@mui/material/styles'
import { T } from '@transifex/react'
import { ReactNode } from 'react'

type FieldLabelProps = {
  required?: boolean
  children: string | ReactNode
  htmlFor?: string
  disabled?: boolean
  labelStyle?: SxProps
  color?: InputLabelOwnProps['color']
}

/**
 * Design System Notes:
 * - Do not make field labels red on error
 */

const FieldLabel: React.FC<FieldLabelProps> = ({
  required = true,
  children,
  htmlFor,
  disabled = false,
  labelStyle,
  color,
}) => {
  return (
    <InputLabel
      sx={{ fontWeight: semiBoldFontWeight, marginBottom: 0.5, ...labelStyle }}
      htmlFor={htmlFor}
      disabled={disabled}
      color={color}>
      {children}
      {!required && (
        <>
          &nbsp; <T _str=" (optional)" />
        </>
      )}
    </InputLabel>
  )
}

export default FieldLabel
